module.exports = {
	Back: require ("./Back").default,
	Cubic: require ("./Cubic").default,
	Elastic: require ("./Elastic").default,
	Expo: require ("./Expo").default,
	IEasing: require ("./IEasing").default,
	Linear: require ("./Linear").default,
	Quad: require ("./Quad").default,
	Quart: require ("./Quart").default,
	Quint: require ("./Quint").default,
	Sine: require ("./Sine").default
}